<!-- 
CustomerIdView.vue
功能：客戶ID異動_查詢檢視
作者：i9400538 陳博承
完成：2021-09-23
-->
<template>
  <main>
    <tab-header-customer-id />
    <div class="tab-content">
      <div class="tab-pane active show">
        <div class="container">
          <div class="row">
            <div class="col-12">
              <!-- Search Block-->
              <table id="searchBlock">
                <thead>
                  <tr>
                    <th width="30%">
                      <select
                        :id="`input_type-${colKey}`"
                        :data-vv-name="`input_type-${colKey}`"
                        v-validate="'required'"
                        data-vv-as="查詢條件"
                        class="form-control select-width"
                        :class="{ 'is-invalid': errors.has(`input_type-${colKey}`) }"
                        v-model="input_type"
                      >
                        <option value>請選擇</option>
                        <option
                          v-for="(item, index) in queryOpt"
                          :key="index"
                          :value="item.val"
                        >{{item.text}}</option>
                      </select>
                    </th>
                    <td>
                      <input
                        type="text"
                        maxlength="20"
                        :id="`input_text-${colKey}`"
                        :data-vv-name="`input_text-${colKey}`"
                        placeholder="請輸入查詢內容"
                        v-validate="'required'"
                        data-vv-as="查詢內容"
                        class="form-control"
                        v-model="input_text"
                        alt="ch"
                        :class="{ 'is-invalid': errors.has(`input_text-${colKey}`) }"
                        @keydown.enter="doQuery(true, false)"
                      />
                    </td>
                    <td>
                      <a class="btn btn-primary" @click="doQuery(true, false)">查詢</a>
                    </td>
                  </tr>
                  <tr>
                    <th width="30%">異動日期</th>
                    <td class="text-center">
                      <select
                        :id="`start-date-year-${colKey}`"
                        :data-vv-name="`start-date-year-${colKey}`"
                        v-validate="'required'"
                        data-vv-as="異動日期(起)"
                        class="form-control form-control-inline"
                        v-model="start_date[0]"
                        :class="{ 'is-invalid': errors.has(`start-date-year-${colKey}`) }"
                      >
                        <option
                          v-for="(opt, y_opt_i) in yearOpt"
                          :key="`start-year-${y_opt_i}`"
                          :value="opt"
                        >{{opt - 1911}}年</option>
                      </select>
                      <span class="text">/</span>
                      <select
                        :id="`start-date-month-${colKey}`"
                        :data-vv-name="`start-date-month-${colKey}`"
                        v-validate="'required'"
                        data-vv-as="異動日期(起)"
                        class="form-control form-control-inline"
                        v-model="start_date[1]"
                        :class="{ 'is-invalid': errors.has(`start-date-month-${colKey}`) }"
                      >
                        <option
                          v-for="(opt, m_opt_i) in monthOpt"
                          :key="`start-month-${m_opt_i}`"
                          :value="opt"
                        >{{opt}}月</option>
                      </select>
                      ~
                      <select
                        :id="`end-date-year-${colKey}`"
                        :data-vv-name="`end-date-year-${colKey}`"
                        v-validate="'required'"
                        data-vv-as="異動日期(訖)"
                        class="form-control form-control-inline"
                        v-model="end_date[0]"
                        :class="{ 'is-invalid': errors.has(`end-date-year-${colKey}`) }"
                      >
                        <option
                          v-for="(opt, y_opt_i) in yearOpt"
                          :key="`end-year-${y_opt_i}`"
                          :value="opt"
                        >{{opt - 1911}}年</option>
                      </select>
                      <span class="text">/</span>
                      <select
                        :id="`end-date-month-${colKey}`"
                        :data-vv-name="`end-date-month-${colKey}`"
                        v-validate="'required'"
                        data-vv-as="異動日期(訖)"
                        class="form-control form-control-inline"
                        v-model="end_date[1]"
                        :class="{ 'is-invalid': errors.has(`end-date-month-${colKey}`) }"
                      >
                        <option
                          v-for="(opt, m_opt_i) in monthOpt"
                          :key="`end-month-${m_opt_i}`"
                          :value="opt"
                        >{{opt}}月</option>
                      </select>
                    </td>
                    <td>
                      <a class="btn btn-primary" @click="doQuery(false, false)">查詢</a>
                    </td>
                  </tr>
                </thead>
              </table>
              <hr />
              <!-- DataTable Block-->
              <section class="newTable">
                <h4>
                  <span class="text-green">明細列表 : 共{{totalCount}}位</span>
                </h4>
                <table
                  class="table datatable table-striped area-list-datatable"
                  id="CustomerIdDataTable"
                >
                  <thead>
                    <tr>
                      <th id="th_sel" width="80">
                        <span>#</span>
                      </th>
                      <th
                        id="th_modify_date"
                        :class="'sorting ' + (order.fieldName == 'modify_date' ? (order.asc ? 'sorting_asc' : 'sorting_desc') : '')"
                        @click="columnSorting('modify_date')"
                      >異動日期</th>
                      <th
                        id="th_form_id"
                        :class="'sorting ' + (order.fieldName == 'form_id' ? (order.asc ? 'sorting_asc' : 'sorting_desc') : '')"
                        @click="columnSorting('form_id')"
                      >簡覆表編號</th>
                      <th
                        id="th_cust_new"
                        :class="'sorting ' + (order.fieldName == 'cust_new' ? (order.asc ? 'sorting_asc' : 'sorting_desc') : '')"
                        @click="columnSorting('cust_new')"
                      >新客戶ID</th>
                      <th
                        id="th_cust_old"
                        :class="'sorting ' + (order.fieldName == 'cust_old' ? (order.asc ? 'sorting_asc' : 'sorting_desc') : '')"
                        @click="columnSorting('cust_old')"
                      >原客戶ID</th>
                      <th
                        id="th_form_agnt_id"
                        :class="'sorting ' + (order.fieldName == 'form_agnt_id' ? (order.asc ? 'sorting_asc' : 'sorting_desc') : '')"
                        @click="columnSorting('form_agnt_id')"
                      >業務員ID</th>
                      <th
                        id="th_upd_memo"
                        :class="'sorting ' + (order.fieldName == 'upd_memo' ? (order.asc ? 'sorting_asc' : 'sorting_desc') : '')"
                        @click="columnSorting('upd_memo')"
                      >備註</th>
                      <th
                        id="th_emp_name"
                        width="148"
                        :class="'sorting ' + (order.fieldName == 'emp_name' ? (order.asc ? 'sorting_asc' : 'sorting_desc') : '')"
                        @click="columnSorting('emp_name')"
                      >輸入人員</th>
                    </tr>
                  </thead>
                  <tbody class="block-height">
                    <tr v-for="(d, did) in showList" :key="`CustomerIdDataTable-table-td-${did}`">
                      <td width="80">
                        <span class="no">{{did + 1}}</span>
                      </td>
                      <td>{{d.modify_date | dateFormat}}</td>
                      <td>{{d.form_id}}</td>
                      <td>                
                        <Tooltip
                          :position="did < 3 ? 'bottom' : 'top'"
                          expand_col1="新客戶ID"
                          :expand_col1_value="d.cust_new"
                          expand_col2="原客戶ID"
                          :expand_col2_value="d.cust_old"
                          expand_col3="業務員ID"
                          :expand_col3_value="d.form_agnt_id"
                          expand_col4="輸入人員"
                          :expand_col4_value="d.emp_name"                     
                        >
                        {{d.cust_new | getMaskID}}
                        </Tooltip>
                      </td>
                      <td>{{d.cust_old | getMaskID}}</td>
                      <td>{{d.form_agnt_id | getMaskID}}</td>
                      <td>{{d.upd_memo}}</td>
                      <td :width="iPadWidth">{{d.emp_name | getMaskName}}</td>
                    </tr>
                    <tr v-if="showList.length == 0">
                      <td colspan="6" class="text-center pt-3 pb-5">
                        <h3>無任何資料</h3>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </section>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 打開遮罩 -->
    <mxMask :open="mxMaskOpen" />
  </main>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { commonMixin } from "@/mixins/common";
import { setTimeout } from "timers";

//component
import TabHeaderCustomerId from "@/desktop/components/backend/TabHeaderCustomerId";
import mxMask from "@/desktop/components/mxMask";
import Tooltip from "@/desktop/components/ToolTip";
//service
import { queryCustomerIdData } from "@/service";
//parameter
const is_iPad = navigator.userAgent.match(/iPad/i) != null; // 確認裝置是否為 iPad
let idmarkWidth = 148;
if (is_iPad) {
  idmarkWidth = 131;
}

export default {
  name: "CustomerIdView",
  mixins: [commonMixin],
  components: {
    TabHeaderCustomerId,
    mxMask,
    Tooltip
  },
  data() {
    return {
      today: window.moment(),
      mxMaskOpen: false,
      input_type: "",
      input_text: "",
      start_date: ["", ""],
      end_date: ["", ""],
      colKey: "search",
      queryOpt: [
        { text: "簡覆表編號", val: "1" },
        { text: "新客戶ID", val: "2" },
        { text: "原客戶ID", val: "3" },
        { text: "輸入人員", val: "4" }
      ],
      yearOpt: [],
      monthOpt: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
      showList: [], //顯示資料
      order: {
        fieldName: "emp_name",
        asc: true
      },
      iPadWidth: idmarkWidth,
      queryMark: false //紀錄此次查詢類型(欄位排序用)
    };
  },
  computed: {
    ...mapGetters(["UserInfo"]),
    totalCount() {
      return this.showList.length;
    }
  },
  methods: {
    ...mapActions(["setPageLock"]),
    //欄位排序
    columnSorting(fieldName) {
      //切換表頭圖案
      if (this.order.fieldName == fieldName) {
        this.order.asc = !this.order.asc;
      } else {
        this.order.fieldName = fieldName;
        this.order.asc = true;
      }

      if (fieldName == "emp_name") {
        this.doQuery(this.queryMark, true);
        return;
      }

      //data排序
      let sortOrder = -1;
      if (this.order.asc) {
        sortOrder = 1;
      }

      switch (fieldName) {
        case "modify_date":
          setTimeout(() => {
            this.showList.sort(this.dateCompareFun(sortOrder, fieldName));
            this.registerHanlink(); // 難字顯示
          }, 20);
          break;
        default:
          setTimeout(() => {
            this.showList.sort(this.sortCompareFun(sortOrder, fieldName));
            this.registerHanlink(); // 難字顯示
          }, 20);
      }
    },
    sortCompareFun(sortOrder, property) {
      return function(a, b) {
        let result =
          a[property] < b[property] ? -1 : a[property] > b[property] ? 1 : 0;
        return result * sortOrder;
      };
    },
    //日期排序
    dateCompareFun(sortOrder, property) {
      return function(a, b) {
        let date_a = new Date(
          a[property] ? a[property] : "1880-01-01"
        ).getTime();
        let date_b = new Date(
          b[property] ? b[property] : "1880-01-01"
        ).getTime();
        let result = date_a < date_b ? -1 : 1;
        return result * sortOrder;
      };
    },
    //查詢 (isBtn1:點擊第一個查詢按鈕, isColClick:點擊輸入人員欄位)
    doQuery(isBtn1, isColClick) {
      this.queryMark = isBtn1;
      let order = !isColClick ? "0" : this.order.asc ? "1" : "2";
      if (isBtn1) {
        //點擊第一個查詢按鈕，執行欄位檢核
        this.$validator.validateAll().then(el => {
          if (!el) {
            let errMsg = [];
            for (let i = 0; i < this.errors.items.length; i++) {
              errMsg.push(this.errors.items[i].msg);
            }
            let showErrMsg = [...new Set(errMsg)];
            showErrMsg.forEach(s => {
              this.$toast.info({ title: s }); //印出檢核後的錯誤訊息
            });
            return;
          }

          this.$validator.reset();

          let queryMap = {
            input_type: this.input_type,
            input_text: this.input_text
          };

          this.mxMaskOpen = true;
          queryCustomerIdData(this.UserInfo.id, queryMap, order).then(
            result => {
              this.mxMaskOpen = false;
              if (result.header && result.header.status == "200") {
                this.showList = result.body.result;
                if (this.showList && this.showList.length == 0) {
                  this.setToastMsg("查無資料");
                }
              } else {
                this.setToastMsg(result.header.message);
              }
            }
          );
        });
      } else {
        //點擊第二個查詢按鈕
        this.$validator.reset();
        let startDate = ""; //查詢的起始日
        let endDate = ""; //查詢的結束日
        let lastDay = ""; //每月最後一天

        let startMonth =
          this.start_date[1].toString().length == 1
            ? "0" + this.start_date[1].toString()
            : this.start_date[1].toString();
        let endMonth =
          this.end_date[1].toString().length == 1
            ? "0" + this.end_date[1].toString()
            : this.end_date[1].toString();

        let start = this.start_date[0] + startMonth;
        let end = this.end_date[0] + endMonth;
        if (parseInt(start) > parseInt(end)) {
          this.setToastMsg("異動日期起始日不可大於結束日");
          return;
        }

        lastDay = new Date(
          this.end_date[0],
          parseInt(this.end_date[1]),
          0
        ).getDate();
        startDate = `${this.start_date[0]}-${startMonth}-01`;
        endDate = `${this.end_date[0]}-${endMonth}-${lastDay}`;

        let queryMap = {
          input_type: "5",
          start_date: startDate,
          end_date: endDate
        };

        this.mxMaskOpen = true;
        queryCustomerIdData(this.UserInfo.id, queryMap, order).then(result => {
          this.mxMaskOpen = false;
          if (result.header && result.header.status == "200") {
            this.showList = result.body.result;
            debugger
            if (this.showList && this.showList.length == 0) {
              this.setToastMsg("查無資料");
            }
          } else {
            this.setToastMsg(result.header.message);
          }
        });
      }
    },
    //查詢條件初始化
    initDate() {
      let year = this.today.year();
      let month = this.today.month() + 1;
      this.start_date[0] = year;
      this.start_date[1] = month;
      this.end_date[0] = year;
      this.end_date[1] = month;
    }
  },
  beforeMount() {
    //檢查使用者是否為通路科/數支科的人
    //檢查使用者是否有後台管理權限
    let divNo = this.UserInfo.divNo;
    let functionId = this.UserInfo.functionId || [];
    if (
      divNo !== "9400400" &&
      divNo !== "9N00200" &&
      !functionId.includes("4")
    ) {
      this.$router.push({ path: "/" });
    }
  },
  mounted() {
    // 監聽視窗寬度
    if (!is_iPad) {
      this.iPadWidth = "131";
    } else {
      this.iPadWidth = "148";
    }
    let start = window.moment().year();
    for (let s = start - 2; s <= start + 2; s++) {
      this.yearOpt.push(s);
    }
    this.initDate();
    let isFromAdd = this.$route.params.isFromAdd || "";
    if (isFromAdd) {
      this.doQuery(false, false);
    }
  }
};
</script>

<style lang="scss" scoped>
.text-center {
  text-align: center;
}

.newTable thead tr,
.newTable tbody tr {
  display: table;
  width: 100%;
  table-layout: fixed;
  border-left: 0;
  border-right: 0;
  border-bottom: 0;

  td {
    word-break: break-all;
  }

  &.sorting,
  &.sorting_desc {
    position: relative;
    padding-right: 25px !important;

    &:before,
    &:after {
      content: "";
      position: absolute;
      width: 0px;
      height: 0px;
      display: block;
      top: 0;
      bottom: 0;
      right: 6px;
      margin: auto;
    }

    &:after {
      top: 18px;
      border-top: 6px solid transparentize(#027a39, 0.5);
      border-left: 5px solid transparent;
      border-right: 5px solid transparent;
      border-bottom: 6px solid transparent;
    }

    &:before {
      top: -13px;
      border-bottom: 6px solid transparentize(#027a39, 0.5);
      border-left: 5px solid transparent;
      border-right: 5px solid transparent;
      border-top: 6px solid transparent;
    }
  }

  &.sorting_asc:before {
    border-bottom: 6px solid transparentize(white, 0.5);
  }

  &.sorting_desc:after {
    border-top: 6px solid transparentize(white, 0.5);
  }

  &.no-sort:before,
  &.no-sort:after {
    display: none;
  }
}

.newTable tbody.block-height {
  display: block;
  height: 350px;
  overflow-y: scroll;
  border: 0 !important;
  -webkit-overflow-scrolling: touch;

  &::-webkit-scrollbar {
    width: 17px;
    border: 0;
    box-shadow: none;
  }

  &::-webkit-scrollbar-track {
    box-shadow: none;
    border-radius: 0px;
    border: 0;
    background-color: #f5f5f5;
  }

  &::-webkit-scrollbar-thumb {
    width: 10px;
    border-radius: 20px;
    background-color: #555;
  }
}

.table.datatable {
  tbody {
    tr > td {
      &:first-child {
        padding-top: 10px;
      }
    }
  }
}
</style>
